module.exports = __webpack_public_path__ + "static/img/classroom_1.7a40544.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/classroom_1.jpg
// module id = j1E4
// module chunks = 3